module.exports = __webpack_public_path__ + "static/media/homeImage.01df0f62.svg";